export const lesp_item = [
  
  {
    lesp_item_text: "Es un laboratorio de diagnóstico y referencia a nivel Estatal y Regional. Realiza pruebas y análisis para determinar la calidad fisicoquímica y microbiológica de aguas, alimentos y bebidas, productos de uso y consumo humano y otros que representen un riesgo para la salud, así mismo analiza muestras de origen Humano, para coadyuvar en las actividades de vigilancia epidemiológica que se desarrollan en la Entidad. Actividades que se realizan en el marco de las normas y procedimientos que emitan las autoridades competentes y que sean de observancia directa en los laboratorios de este tipo. Coordina, asesora y supervisa técnicamente a la Red Estatal de Laboratorios.",
    lesp_item_list: [
      "Se encuentra ubicado en Dirección: Boulevard Luis Donaldo Colosio s/n",
      "Col. Parque de Poblamiento C.P. 42088, Pachuca de Soto Hidalgo,",
      "teléfono: 771 716 5814 y 771 716 5817",
      "correo electrónico: atención.usuarios@lesphidalgo.gob.mx",
      { label: "Pagina web: lesph.ssh.gob.mx", url: "https://lesph.ssh.gob.mx/" },
      
    ],
  },
]